// extracted by mini-css-extract-plugin
module.exports = {"container":"SphereWave_container__Vrm1e","canvasWrapper":"SphereWave_canvasWrapper__1amsY"};